import { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";
import { usePrefs } from "@/lib/context";
import { DICT, LANGS } from "@/lib/i18n";
import { fetcher } from "@/lib/hooks";
import { ReviewsPanel } from "@/components/Reviews";
import { fillThanks } from "@/pages/PublicTrack";

const SAMPLE = { guest: "Paul", driver: "Marc", rating: 5 };

export function ThankYouSettings({ isAdmin }) {
  const { t } = usePrefs();
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["thank-you"], queryFn: () => fetcher("/settings/thank-you") });
  const [f, setF] = useState({});
  useEffect(() => { if (data) setF(data); }, [data]);
  const save = async () => {
    try { await api.put("/settings/thank-you", f); qc.invalidateQueries({ queryKey: ["thank-you"] }); toast.success(t("saved")); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-6">
      <section className="rounded-sm border border-slate-200 bg-white p-5" data-testid="thank-you-settings">
        <h3 className="font-display text-lg font-bold">{t("thankYouSettings")}</h3>
        <p className="mb-4 mt-1 text-xs text-slate-500">{t("thankYouHint")}</p>
        <div className="space-y-4">
          {LANGS.map(([l, n]) => (
            <div key={l} className="grid gap-2 md:grid-cols-[110px_1fr_1fr]">
              <span className="pt-2 text-xs font-bold uppercase text-slate-600">{l} · {n}</span>
              <Textarea dir={l === "ar" ? "rtl" : "ltr"} rows={2} maxLength={500} disabled={!isAdmin} value={f[l] || ""} placeholder={fillThanks(DICT[l].thanksAutoNamed, { guest: "{guest}", driver: "{driver}", rating: "{rating}" })}
                onChange={(e) => setF({ ...f, [l]: e.target.value })} data-testid={`thank-you-input-${l}`} />
              <div dir={l === "ar" ? "rtl" : "ltr"} className="rounded-sm bg-[#fdf8ec] p-2.5 text-xs text-slate-700" data-testid={`thank-you-preview-${l}`}>
                <span className="me-1 text-[10px] font-bold uppercase text-[#996515]">{t("preview")}</span>{fillThanks(f[l] || DICT[l].thanksAutoNamed, SAMPLE)}
              </div>
            </div>
          ))}
        </div>
        {isAdmin && <Button onClick={save} className="mt-4 rounded-sm bg-[#0F172A]" data-testid="thank-you-save-button">{t("save")}</Button>}
      </section>
      <ReviewsPanel />
    </div>
  );
}
